import { render, staticRenderFns } from "./request-product.vue?vue&type=template&id=88f8cc06"
import script from "./request-product.vue?vue&type=script&lang=js"
export * from "./request-product.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./request-product.vue?vue&type=style&index=1&id=88f8cc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports